<template>
  <div style="width: 100%">
    <v-container class="px-8 py-5">
      <v-row>
        <v-col>
          <v-row class="body-2 font-weight-light">
            <span>Nastavni planovi</span>
            <v-spacer></v-spacer>
            <span>{{ $todayDate() }}</span>
          </v-row>
          <v-row class="py-6">
            <v-col cols="12" sm="3">
              <v-select
                  :items="classes"
                  v-model="selectedClass"
                  class="mr-4"
                  item-text="text"
                  item-value="value"
                  dense
                  height="44"
                  hide-details
                  outlined
                  style="width: 100%"
              ></v-select>
            </v-col>

            <v-col cols="12" sm="3" v-if="$checkPermission('school_plans filter_by_canton')">
              <v-select
                  :items="cantons"
                  v-model="selectedCanton"
                  class="mr-4"
                  item-text="title"
                  item-value="id"
                  dense
                  height="44"
                  hide-details
                  outlined
                  style="width: 100%"
              ></v-select>
            </v-col>

            <v-col cols="12" sm="3">
              <v-text-field
                  outlined
                  placeholder="Pretraži nastavne planove..."
                  hide-details
                  dense
                  v-model="search"
                  height="44"
                  append-icon="mdi-magnify"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-btn
                  @click="$router.push('nastavni_planovi/dodaj_plan')"
                  class="primary text-none"
                  v-if="$checkPermission('school_plans create')"
                  block
                  height="44"
                  depressed
              >
                <v-icon left>mdi-plus</v-icon>
                Dodaj
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="justify-center">
            <v-data-table
                @click:row="openDetails"
                :headers="headers"
                :items="schoolPlans"
                :options.sync="options"
                :server-items-length="totalItems"
                style="cursor:pointer;"
                loading-text="Traženje..."
                :footer-props="{itemsPerPageText: 'Redaka po stranici:'}"
                :header-props="{sortByText: 'Poredaj po'}"
            >
              <template v-slot:[`item.id`]="{item}">
                <v-btn
                    class="action-button elevation-0 mr-2"
                    color="primary"
                    @click.stop="$router.push(`nastavni_planovi/${item.id}/uređivanje`)"
                    v-if="$checkPermission('school_plans edit')"
                >
                  <v-icon
                      color="white"
                      size="16"
                  >mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn
                    class="action-button elevation-0 mr-2"
                    color="secondary"
                    @click.stop="duplicateSchoolPlan(item)"
                    v-if="$checkPermission('school_plans create')"
                >
                  <v-icon
                      color="white"
                      size="16"
                  >mdi-content-copy
                  </v-icon>
                </v-btn>
                <v-btn
                    class="action-button red darken-2 elevation-0"
                    @click.stop="deleteDialog = true; currentPlanId = item.id;"
                    v-if="$checkPermission('school_plans delete')"
                >
                  <v-icon
                      color="white"
                      size="16"
                  >mdi-delete
                  </v-icon>
                </v-btn>
              </template>

              <template v-slot:[`item.school_class`]={item}>
                <span>{{ (+item.school_class > 10) ? `${+item.school_class - 10}. razred (Srednja škola)` : `${item.school_class}. razred` }}</span>
              </template>
              <template v-slot:no-data>
            <span>
                Za tražene pojmove nema rezultata pretrage.
            </span>
              </template>
              <template v-slot:[`footer.page-text`]="items"> Prikazano {{ items.pageStart }} do {{ items.pageStop }} od
                ukupno
                {{ items.itemsLength }} rezultata
              </template>
            </v-data-table>

          </v-row>

        </v-col>
      </v-row>
    </v-container>

    <v-dialog
            v-model="deleteDialog"
            width="500">

        <v-card>
            <v-card-title
                    primary-title>
                {{ dialogTitle }}
            </v-card-title>

            <v-card-text style="padding-top: 20px;">
                {{ deleteText }}
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="deleteDialog = false" depressed large outlined>Odustani</v-btn>
                <v-btn @click="deleteSchoolPlan()" color="error" depressed large>Izbriši</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {serverBus} from "../../main";
import ApiV2 from '../../services/ApiV2'

export default {
  name: 'Home',
  components: {},
  data: () => ({
    schoolPlans: [],
    cantons: [],
    selectedClass: null,
    search: '',
    currentPlanId: null,
    selectedCanton: null,
    deleteText: 'Operacija koju ste zatražili može imati za posljedicu gubitak određenog dijela podataka. Jeste li sigurni da želite izbrisati odabrani resurs?',
    dialogTitle: 'Jeste li sigurni?',
    deleteDialog: false,
    options: {},
    totalItems: 0,
  }),
  computed: {
    classes() {
      let classNames = [{value: null , text: 'Svi razredi'}, {header: 'Osnovna škola'}]
      for (let i = 1; i <= 14; i++) {
        if (i > 10) {
          classNames.push({value: i, text: `${i % 10}. razred`})
        } else if (i !== 10) {
          classNames.push({value: i, text: `${i}. razred`});
        } else {
          classNames.push({divider: true})
          classNames.push({header: "Srednja škola"})
        }
      }
      return classNames;
    },
    headers() {
      return [
        {text: 'Naziv nastavnog plana', value: 'title'},
        {text: 'Razred', value: 'school_class'},
        {text: 'Akcija', value: 'id', align: 'center'},
      ]
    },

    currentRole() {
      return this.$store.getters.getCurrentRole;
    }
  },
  methods: {
    getPlans() {
      const classFilter = (this.selectedClass) ? this.selectedClass : undefined;
      const cantonFilter = (this.selectedCanton) ? this.selectedCanton : undefined;

      let params = {
        page: this.options.page,
        perPage: this.options.itemsPerPage,
        sortDesc: this.options.sortDesc,
        sortBy: this.options.sortBy,
        filter: {
          title: '~=' + this.search,
          school_class: classFilter,
          canton_id: cantonFilter
        }
      }

      ApiV2.get(`school_plans`, {
        params: params
      }).then(response => {
        this.schoolPlans = response.data.data;
        this.totalItems = response.data.total;
      });
    },

    async duplicateSchoolPlan(plan){
      let {data} = await ApiV2.get(`school_plans/${plan.id}/duplicate`)
      this.schoolPlans.push(data)
    },

    getCantons() {
      this.axios.post('zupanija')
        .then(response => {
          this.cantons = response.data.items;
          this.cantons.unshift({id: null, title:'Sve županije'});
        })
    },

    openDetails(schoolPlan) {
      this.$router.push(`nastavni_planovi/${schoolPlan.id}`)
    },
    deleteSchoolPlan() {
      this.$axios.delete(`/v2/school_plans/${this.currentPlanId}`)
          .then(() => {
            this.dialog = false;
            serverBus.$emit('show-snackbar', true, 'Uspješno se izbrisali nastavni plan.');
            this.getPlans();
          })
          .catch(() => {
            serverBus.$emit('show-snackbar', false);
          });
    }
  },

  created() {
    if(localStorage.getItem('plans-options')){
      this.options = JSON.parse(localStorage.getItem('plans-options'));
      this.search = this.options.search
      this.selectedCanton = this.options.selectedCanton
      this.selectedClass = this.options.selectedClass
    }
    this.getCantons();
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.options.search = this.search;

        localStorage.setItem('plans-options', JSON.stringify(this.options));
        this.getPlans()
      }
    },
    currentRole: {
      deep: true,
      handler() {
        this.selectedCanton = null
        this.options.page = 1
        this.getPlans()
      }
    },
    search: {
      handler() {
        this.options.page = 1
         this.options.search = this.search;

        localStorage.setItem('plans-options', JSON.stringify(this.options));
        this.getPlans()
      },
      deep: true
    },
    selectedCanton: {
      handler() {
        this.options.page = 1
         this.options.selectedCanton = this.selectedCanton;

        localStorage.setItem('plans-options', JSON.stringify(this.options));
        this.getPlans()
      },
      deep: true
    },
    selectedClass: {
      handler() {
        this.options.page = 1
        this.options.selectedClass = this.selectedClass;

        localStorage.setItem('plans-options', JSON.stringify(this.options));
        this.getPlans()
      },
      deep: true
    }
  }
}
</script>

<style>
.action-button {
  height: 32px !important;
  min-width: 32px !important;
  width: 32px;
}
</style>